/**
 * Goal API
 * @namespace GoalApi
 */

import Api from "@/helpers/fetch";


export default class GoalApi {
    /**
     * Get all goals
     * @memberof GoalApi
     * @param {number} user_id - User id
     * @param {function} callback - Callback function
     */
    static async getAllGoals({user_id, callback =() => {}} = {}) {
        const url = `stakeapi/v1/goals-assigned-to/${user_id}`
        const res =  await Api.fetch({
            url,
            method : "GET"
        })

        if(res) callback(res)
    }


    /**
     * Create new gual
     * @param {Object} params - {}
     * @param {Function} callback
     */

    static async createNewGoal({params, callback = () => {}} = {}) {
        const url = `stakeapi/v1/goals/create`
        const res = await Api.fetch({
            url,
            method : "POST",
            params
        })

        if(res) callback(res)
    }

    /**
     * Get goal by id
     * @param {Number} goal_id - Goal id
     * @param {Function} callback
     */
    static async getGoalById({goal_id, callback = () => {}} = {}) {   
        
        const url = `stakeapi/v1/goals/retrieve/${goal_id}`
        const res = await Api.fetch({
            url,
            method : "GET"
        })

        if(res) callback(res)
    }


    /**
     * Update goal
     * @param {Object} params - {}
     * @param {Function} callback
     */
    static updateGoal = async ({params, callback = () => {}} = {}) => {
        const url = `stakeapi/v1/goals/update/${params.id}`
        const res = await Api.fetch({
            url,
            method : "POST",
            params
        })

        if(res) callback(res)
    }

    /**
     * Add more task   
     * @param {Object} params - {}
     * @param {Number} goal_id - Goal id
     * @param {Function} callback
     */
    static addMoreTask = async ({params, goal_id, callback = () => {}} = {}) => {
        const url = `stakeapi/v1/goals/add_task`
        const res = await Api.fetch({
            url,
            method : "POST",
            params : {...params, goal_id}
        })

        if(res) callback(res)  
    }

    /**
     * Delete Goal
     * @param {Number} goal_id - Goal id 
     * @param {Function} callback
     */
    static deleteGoal = async ({goal_id, callback = () => {}} = {}) => {
        const url = `stakeapi/v1/goals/delete/${goal_id}`
        const res = await Api.fetch({
            url,
            method : "POST"
        })

        if(res) callback(res)
    }   

    /**
     * Update task
     * @param {Object} params - {}
     * @param {Function} callback
     */
    static updateTask = async ({params, callback = () => {}} = {}) => {
        const url = `stakeapi/v1/goals/update_task`
        const res = await Api.fetch({
            url,
            method : "POST",
            params
        })

        if(res) callback(res)
    }

    /**
     * Delete task
     * @param {Number} task_id - Task id
     * @param {Number} goal_id - Goal id
     * @param {Function} callback
     * 
     */

    static deleteTask = async ({task_id, goal_id, callback = () => {}} = {}) => {
        const url = `stakeapi/v1/goals/remove_task`
        const res = await Api.fetch({
            url,
            method : "POST",
            params : {task_id, goal_id}
        })

        if(res) callback(res)
    }

    /**
     * Complete task
     * @param {Number} task_id - Task id
     * @param {Number} goal_id - Goal id
     * @param {Number} user_id - User id
     * @param {Function} callback
     */
    static completeTask = async ({task_id, goal_id, user_id, callback = () => {}} = {}) => {
        const url = `stakeapi/v1/goals/complete_task`
        const res = await Api.fetch({
            url,
            method : "POST",
            params : {task_id, goal_id, user_id}
        })

        if(res) callback(res)
    }

    /**
     * Get goal users
     * @param {Function} callback
     */
    static getGoalUsers = async ({callback = () => {}} = {}) => {
        
        const url = `stakeapi/v1/goals-users-list`
        const res = await Api.fetch({
            url,
            method : "GET"
        })

        if(res) callback(res)
    }

    /**
     * Assign user to goal
     * @param {Number} goal_id - Goal id
     * @param {Number} assigned_user_id - User id
     */
    static assignUserToGoal = async ({goal_id, assigned_user_id, callback = () => {}} = {}) => {
        const url = `stakeapi/v1/goals/assign_user`
        const res = await Api.fetch({
            url,
            method : "POST",
            params : {goal_id, assigned_user_id}
        })

        if(res) callback(res)
    }

    /**
     * Remove user from goal
     * @param {Number} goal_id - Goal id
     * @param {Number} assigned_user_id - User id
     */
    static removeUserFromGoal = async ({goal_id, assigned_user_id, callback = () => {}} = {}) => {
        const url = `stakeapi/v1/goals/remove_user`
        const res = await Api.fetch({
            url,
            method : "POST",
            params : {goal_id, assigned_user_id}
        })

        if(res) callback(res)
    }

    /**
     * Get assigned goals to user
     * @param {Number} user_id - User id
     * @param {Function} callback
     */
    static getAssignedGoals = async ({user_id, callback = () => {}} = {}) => {
        const url = `stakeapi/v1/goals-assigned-to/${user_id}`
        const res = await Api.fetch({
            url,
            method : "GET"
        })

        if(res) callback(res)
    }

    /**
     * Get user owned goals
     * @param {Number} user_id - User id
     * @param {Function} callback
     * 
     */
    static getUserOwnedGoals = async ({user_id, callback = () => {}} = {}) => {
        const url = `stakeapi/v1/goals-by-author/${user_id}`
        const res = await Api.fetch({
            url,
            method : "GET"
        })

        if(res) callback(res)
    }

    /**
     * Get all goals
     * @param {Function} callback
     */
    static getAllGoalsList = async ({callback = () => {}} = {}) => {
        const url = `stakeapi/v1/goals/all`
        const res = await Api.fetch({
            url,
            method : "GET"
        })

        if(res) callback(res)
    }
}